import './Legal.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p className="updated">Last updated: March 2026</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          KeepOrDel ("we," "our," or "the app") is committed to protecting your privacy. This Privacy Policy explains how the KeepOrDel mobile application handles information when you use it. KeepOrDel is a fully offline application—no account or login is required, and we do not collect, store, or transmit your personal data to any server.
        </p>
      </section>

      <section>
        <h2>2. Information We Do Not Collect</h2>
        <p>
          KeepOrDel does not collect, store, or transmit any personal information. The app does not require you to create an account or log in. We do not collect your name, email address, device identifiers, or any other personally identifiable information through the app.
        </p>
      </section>

      <section>
        <h2>3. Photo Library Access</h2>
        <p>
          To allow you to sort your photos (swipe right to keep, swipe left to delete), KeepOrDel requests permission to access your device's photo library. This access is used only on your device. Your photos are never uploaded, sent to our servers, or shared with third parties. All processing happens locally on your device.
        </p>
      </section>

      <section>
        <h2>4. Offline Operation</h2>
        <p>
          The app is designed to work entirely offline. It does not require an internet connection to sort your gallery. Because the app does not connect to external servers for its core functionality, there is no opportunity for your photos or usage data to be transmitted over the network by the app itself.
        </p>
      </section>

      <section>
        <h2>5. Third-Party Services</h2>
        <p>
          KeepOrDel does not integrate third-party analytics, advertising, or tracking SDKs within the app. If you contact the developer through the developer contact website, any information you provide in that context (e.g., email, name, message) is subject to how you choose to communicate and is not covered by in-app data collection, as the app itself does not collect such data.
        </p>
      </section>

      <section>
        <h2>6. Children's Privacy</h2>
        <p>
          KeepOrDel does not knowingly collect any personal information from anyone, including children. The app is suitable for general use and does not target children specifically.
        </p>
      </section>

      <section>
        <h2>7. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be reflected in the app store listing and/or within the app if applicable. Continued use of the app after changes constitutes acceptance of the updated policy.
        </p>
      </section>

      <section>
        <h2>8. Contact</h2>
        <p>
          If you have questions about this Privacy Policy or KeepOrDel, you can contact the developer at{' '}
          <a href="mailto:baralnishan987@gmail.com">baralnishan987@gmail.com</a> (Nishan Baral).
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
